import { ArtboardFilter } from '../types'
import { defaultShaderSource } from './shaders'
import { grayscaleShaderSource } from './shaders/grayscale'
import { rainbowShaderSource } from './shaders/rainbow'
import { rumbleShaderSource } from './shaders/rumble'
import { vhsShaderSource } from './shaders/vhs'
import { wavyShaderSource } from './shaders/wavy'

export function createShaderProgram(gl: WebGLRenderingContext, fragmentSource: string, vertexSource: string) {
    const fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fragmentSource)!
    const vertexShader = loadShader(gl, gl.VERTEX_SHADER, vertexSource)!
    const program = gl.createProgram()!

    gl.attachShader(program, vertexShader)
    gl.attachShader(program, fragmentShader)
    gl.linkProgram(program)

    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        throw `unable to create shader program`
    }

    return program
}

export function loadShader(gl: WebGLRenderingContext, type: number, source: string) {
    const shader = gl.createShader(type)!

    gl.shaderSource(shader, source)
    gl.compileShader(shader)

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        throw `unable to compile shader`
    }

    return shader
}

export function shaderSourceFromFilter(filter?: ArtboardFilter) {
    switch (filter) {
        case 'grayscale':
            return grayscaleShaderSource
        case 'rainbow':
            return rainbowShaderSource
        case 'rumble':
            return rumbleShaderSource
        case 'vhs':
            return vhsShaderSource
        case 'wavy':
            return wavyShaderSource
        default:
            return defaultShaderSource
    }
}
